// src/features/settings/components/product-groups-panel/ProductGroupCreateForm.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Checkbox,
  Collapse,
  TextField,
  Typography,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { FORM_MAX_WIDTH, FormActions, FormSection } from '../../../../components/common/form';

const BOOLEAN_FIELDS = ['lot_tracked', 'inventory_tracked', 'serial_tracked', 'hazardous'];

export default function ProductGroupCreateForm({ visible, values, errors, loading, onChange, onSubmit, onCancel }) {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <Collapse in={visible}>
      <Box sx={{ maxWidth: FORM_MAX_WIDTH, display: 'flex', flexDirection: 'column', gap: 5, mb: 5 }}>
        <FormSection title={t('settings:product_groups.dialog.create_title')}>

          <Box display="flex" flexDirection="column" gap={3}>
            <Box display="flex" gap={3}>
              <TextField
                label={t('settings:product_groups.grid.code')}
                value={values.code}
                onChange={(e) => onChange('code', e.target.value)}
                fullWidth
                required
                error={Boolean(errors.code)}
                helperText={errors.code}
                inputProps={{ maxLength: 20 }}
                sx={{ width: "150px" }}
              />
              <TextField
                label={t('settings:product_groups.grid.name')}
                value={values.name}
                onChange={(e) => onChange('name', e.target.value)}
                fullWidth
                required
                error={Boolean(errors.name)}
                helperText={errors.name}
                sx={{ flex: 1 }}
              />

            </Box>
            <TextField
              label={t('settings:product_groups.grid.description')}
              value={values.description}
              onChange={(e) => onChange('description', e.target.value)}
              fullWidth
            />
            <TextField
              label={t('settings:product_groups.grid.shelf_life_days')}
              value={values.shelf_life_days}
              onChange={(e) => onChange('shelf_life_days', e.target.value)}
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
            />
          </Box>

        <Box display="flex" gap={3} mt={2} flexWrap="wrap">
          {BOOLEAN_FIELDS.map((field) => (
            <Box key={field} display="flex" alignItems="center" gap={0.5}>
              <Checkbox
                checked={values[field]}
                onChange={(e) => onChange(field, e.target.checked)}
                size="small"
              />
              <Typography variant="body2">
                {t(`settings:product_groups.grid.${field}`)}
              </Typography>
            </Box>
          ))}
        </Box>
        </FormSection>
        <FormActions
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitLabel={t('common:buttons.create')}
          submitIcon={<SaveIcon />}
          loading={loading}
        />
      </Box>
    </Collapse>
  );
}
